import React, { Component } from 'react';
import Fade from 'react-reveal';
import { connect } from 'react-redux';
import work_1 from './../../shared/assets/images/covid/working__3.jpg';
import work_2 from './../../shared/assets/images/covid/working__2.jpg';
import work_3 from './../../shared/assets/images/covid/working__1.jpg';
import lang from '../../lang/lang.json';
import './weAreWorking.scss';

class WeAreWorking extends Component {
  render() {
    return (
      <div className="weAreWorking">
        <div className="container">
          <Fade bottom>
            <div className="row rowWeAreWorking ">
              <div className="col-lg-5">
                <div className="title">
                  {lang.WORKING_TITLE[this.props.language]}
                  <p className="green-border d-block d-md-none mt-md-3 mt-2"></p>
                </div>
                <div className="description">
                  <p>{lang.WORKING_DESCRIPTION_P1[this.props.language]}</p>
                  <p>{lang.WORKING_DESCRIPTION_P2[this.props.language]}</p>
                  <p>{lang.WORKING_DESCRIPTION_P3[this.props.language]}</p>
                </div>
              </div>
              <div className="col div-imgs">
                <div>
                  <img className="work-img-1" src={work_3} alt="" />
                </div>
                <div>
                  <div className="div-imgs-collapse">
                    <img
                      className="work-img-2"
                      width="302px"
                      height="195px"
                      src={work_1}
                      alt=""
                    />
                    <img
                      className="work-img-3"
                      width="167px"
                      height="124px"
                      src={work_2}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language.language,
  };
}

export default connect(mapStateToProps)(WeAreWorking);
